<template>
  <component
    :is="href ? 'a' : 'button'"
    class="marquee-button button"
    v-bind="href ? { href } : {}"
    :disabled="disabled"
    @mouseenter="startMarquee"
    @mouseleave="stopMarquee"
    @click="$emit('click')"
  >
    <span
      v-if="!loading"
      ref="labelRef"
      class="button-label"
      :data-label="label"
    >
      {{ label }}
    </span>
    <span v-else class="loader">
      <svg class="transient" width="20" viewBox="0 0 120 30" fill="currentColor" style="/* opacity: 0; *//* transform: translate(-50%, -50%); */">
        <circle cx="15" cy="15" r="15">
          <animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate>
          <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate>
        </circle>
        <circle cx="60" cy="15" r="9" fill-opacity="0.3">
          <animate attributeName="r" from="9" to="9" begin="0s" dur="0.8s" values="9;15;9" calcMode="linear" repeatCount="indefinite"></animate>
          <animate attributeName="fill-opacity" from="0.5" to="0.5" begin="0s" dur="0.8s" values=".5;1;.5" calcMode="linear" repeatCount="indefinite"></animate>
        </circle>
        <circle cx="105" cy="15" r="15">
          <animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate>
          <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate>
        </circle>
      </svg>
    </span>
  </component>
</template>

<script setup>
import { ref, nextTick } from "vue";
import { gsap } from "gsap";

defineProps({
  label: {
    type: String,
    required: true,
  },
  href: {
    type: String,
    required: false,
    default: () => "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false
  }
});

defineEmits(["click"]);

const labelRef = ref(null);
let marqueeTween = null;

function startMarquee() {
  nextTick(() => {
    const el = labelRef.value;
    if (!el) return;

    const width = el.offsetWidth + 40;

    marqueeTween?.kill();

    marqueeTween = gsap.to(el, {
      x: width,
      ease: "linear",
      duration: width / 50, // Adjust this number to control speed
      repeat: -1,
    });
  });
}

function stopMarquee() {
  marqueeTween?.kill();
  if (labelRef.value) {
    gsap.to(labelRef.value, {
      x: 0,
      duration: 0.2, // smooth return duration
      ease: "power2.out", // soft easing for natural return
    });
  }
}
</script>

<style scoped>
.marquee-button {
  position: relative;
  overflow: hidden;
  white-space: nowrap;
}

.button-label {
  position: relative;
  display: block;
  white-space: nowrap;
  will-change: transform;
}
.loader svg {
  display: inline-block;
}
@media screen and (pointer: fine) {
  .button-label::before {
    content: attr(data-label);
    min-width: max-content;
    position: absolute;
    inset-inline-end: 100%;
    margin-right: 2.5rem;
  }
}
</style>
